import { KweebecWorldPage } from './pages/KweebecWorldPage';

const App = () => <KweebecWorldPage />;

export default App;
